// extracted by mini-css-extract-plugin
export default {"checked":"CheckBox_checked__hCPwZ","uncheck":"CheckBox_uncheck__hv5SK"};